import axiosInstance from "./axiosInstance";

// Fetch menus from the backend
export const createOrder = async (data) => {
  try {
    const response = await axiosInstance.post("/order", data);
    return response.data;
  } catch (error) {
    console.error("Error creating order:", error);
    throw error;
  }
};
